/**
 * Freelance jobs are represented only via jobType (no separate isFreelance flag), same
 * approach as summer jobs — see summer-job-job-type.ts.
 */

const FREELANCE_JOB_TYPE_LOWERCASE = new Set(['freelance', 'keikkatyö', 'frilans']);

export function isFreelanceJobTypeValue(jobType?: string | null): boolean {
  if (!jobType || typeof jobType !== 'string') return false;
  return FREELANCE_JOB_TYPE_LOWERCASE.has(jobType.trim().toLowerCase());
}

export type AppLocale = 'en' | 'fi' | 'sv';

/** Algolia/Typesense `jobType` facet value for the active index locale. */
export function freelanceJobTypeFacetForLocale(locale: AppLocale): string {
  if (locale === 'fi') return 'Keikkatyö';
  if (locale === 'sv') return 'Frilans';
  return 'Freelance';
}
